import { render, staticRenderFns } from "./ResponseMsg.vue?vue&type=template&id=a2fd85ca&scoped=true&"
import script from "./ResponseMsg.vue?vue&type=script&lang=js&"
export * from "./ResponseMsg.vue?vue&type=script&lang=js&"
import style0 from "./ResponseMsg.vue?vue&type=style&index=0&id=a2fd85ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fd85ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VContainer,VFlex,VImg,VLayout,VProgressCircular})
